<template>
  <div class="language-selector-container">
    <div class="selector"
         @click="showLanguageList = !showLanguageList"
         ref="languageSelector">
      <left-icon class="select-icon" :class="{'open': showLanguageList}"/>
      <div class="select-language">
        {{ currentLanguage.value }}
      </div>
    </div>
    <ul class="language-list" v-if="showLanguageList" ref="languageList">
      <li
        v-for="language in languages"
        :key="language.key"
        class="language"
        :class="{ active: language.key === currentLanguage.key }"
        @click="setLanguage(language)"
      >
        {{ language.value }}
      </li>
    </ul>
  </div>
</template>

<script>
  import leftArrowIcon from "@/assets/icons/horti_04-left-12px.svg?inline";

  export default {
    name: "LanguageSelector",
    components: {leftIcon: leftArrowIcon},

    data() {
      return {
        showLanguageList: false,
        languages: [
          { key: "en", value: "English" },
          { key: "nl", value: "Nederlands" }
        ]
      };
    },

    computed: {
      currentLanguage: function() {
        return this.languages.find(lang => lang.key === this._i18n.locale);
      }
    },

    methods: {
      setLanguage(language) {
        if (this.currentLanguage.key !== language.key) {
          this.$router.push({
            query: { ...this.$route.query, locale: language.key }
          });
          this._i18n.locale = language.key;
        }
      },
      closeClickHandler(e) {
        if ( this.$refs.languageList !== undefined && this.$refs.languageList.contains(e.target)) {
          this.showLanguageList = false;
          this.removeClickCloseHandler();
        } else {
          if ( !this.$refs.languageSelector.contains(e.target) ) {
            this.showLanguageList = !this.showLanguageList;
            this.removeClickCloseHandler();
          }
        }
      },

      addClickCloseHandler() {
        document
          .body
          .addEventListener("click", this.closeClickHandler);
      },

      removeClickCloseHandler() {
        document
          .body
          .removeEventListener("click", this.closeClickHandler);
      }
    },

    watch: {
      showLanguageList(newValue) {
        if (newValue) {
          this.addClickCloseHandler();
        }
      }
    }
  };
</script>

<style lang="scss">
  .language-selector-container {
    align-self: flex-end;
    margin-left: auto;
    position: relative;

    .selector {
      display: flex;
      align-items: center;

      .select-language {
        color: $black;
        cursor: pointer;
      }

      .select-icon {
        $size: 10px;
        width: $size;
        height: $size;
        cursor: pointer;
        margin-right: 3px;

        &.open {
          transform: rotate(-90deg);
        }

        #Left-arrow {
          fill: $black;
        }
      }
    }

    .language-list {
      position: absolute;
      color: $black;
      background: $white;
      padding: 10px;
      box-shadow: 0 2px 7px rgba(0, 0, 0, 0.11);
      margin: 0;
      list-style-type: none;
      z-index: map-get($z-index, language-list);
      right: 0;

      .language {
        cursor: pointer;

        &.active {
          color: $pink-500;
        }

        &:hover {
          color: $pink-500;
        }
      }
    }
  }
</style>
